/**
 * Market-scoped empty-search quick actions (V2 chat).
 */
export const getEmptySearchAreaSuggestion = (marketCode = 'LK') => {
  if (String(marketCode).toUpperCase() === 'SG') {
    return {
      place: 'CBD',
      label: 'Try CBD',
      alreadyMatches: (location) => /\b(cbd|central|orchard|marina)\b/i.test(location || ''),
      dispatchQuery: (spaceType) => `show ${spaceType || 'spaces'} in CBD`,
    };
  }
  return {
    place: 'Colombo',
    label: 'Try Colombo',
    alreadyMatches: (location) => /colombo/i.test(location || ''),
    dispatchQuery: (spaceType) => `show ${spaceType || 'spaces'} in Colombo`,
  };
};
